import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { SailorForChecklist } from "../types";
import { calculateSailorCheckList } from "../lib/calculateSailorCheckList";

export const useSailorCheckList = (sailor: SailorForChecklist) => {
  const [progressTracker, loadingProgressTracker, errorProgressTracker] =
    useDocumentData(sailor && doc(db, "sailors_progressTracker", sailor?.id));
  const [riskProfile, loadingRisk, errorRisk] = useDocumentData(
    sailor && doc(db, "sailorRiskProfiles", sailor?.id)
  );

  const loading = loadingProgressTracker || loadingRisk;
  const error = errorProgressTracker || errorRisk;
  const checklist = loading
    ? undefined
    : calculateSailorCheckList(sailor, progressTracker, riskProfile);

  return {
    loading,
    error,
    checklist,
  };
};
